<template>
  <main class="articles resources__page-topic">
    <div class="resources__top-wrap">
      <div class="rich-text-wrapper">
        <RichRenderer :richTextData="page.paragraphRich" />
      </div>
      <div v-if="topics" class="resources__topics-list">
        <a
          v-for="topic in topics"
          :key="topic.title"
          class="resources__topic-anchor text-link"
          @click="anchorTo(topic.title, $refs)"
          v-html="topic.title"
        />
      </div>
    </div>
    <div v-if="topics" class="resources__content resources__content-list">
      <div
        v-for="topic in topics"
        :key="topic.title"
        class="resources__content-topic articles__topic"
      >
        <h3
          :ref="topic.title"
          class="text-color-navy resources__content-topic-title text-h3"
          v-html="topic.title"
        />
        <div class="articles__items-wrapper">
          <accordion v-for="faqItem in topic.items" :key="faqItem.id" :ref="faqItem.id">
            <template #header>
              <div v-html="faqItem.title" />
            </template>
            <template #main>
              <RichRenderer :richTextData="faqItem.paragraphRich" />
            </template>
          </accordion>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import arraySort from 'array-sort'
import { nextTick } from 'vue'

import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'

import { useNavigation } from '@/composables/useNavigation'
import { usePageMeta } from '@/composables/usePageMeta'

export default {
  name: 'Articles',
  props: {
    cPage: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { setPageMeta } = usePageMeta()
    const { getContentTypeId } = useContentfulComponent()
    const { anchorTo, scrollIntoEl } = useNavigation()

    setPageMeta(props.cPage?.fields?.pageMeta)

    return {
      getContentTypeId,
      anchorTo,
      scrollIntoEl,
    }
  },
  data() {
    return {
      topics: null,
    }
  },
  computed: {
    page() {
      return this.cPage.fields
    },
  },
  mounted() {
    this.topics = this.page.includes
      ? arraySort(
          this.page.includes
            .filter((el) => this.getContentTypeId(el) === 'resourceTopic')
            .map((topicEntry) => {
              return topicEntry.fields
                ? {
                    title: topicEntry.fields.title,
                    items: topicEntry.fields.includes
                      .map((faqEntry) => {
                        return faqEntry.fields
                          ? {
                              ...faqEntry.fields,
                              id: faqEntry.sys.id,
                            }
                          : null
                      })
                      .filter((el) => el),
                  }
                : null
            })
            .filter((el) => el),
          'title',
        )
      : null

    nextTick(() => {
      const openFaqTopicFromQuery = () => {
        const topicName = this.$route.hash.substring(1).replaceAll(/_/g, ' ')
        const topicRefs = this.$refs[topicName]
        if (topicRefs?.length) topicRefs[0].scrollIntoView()
      }
      const openFaqItemFromQuery = () => {
        const faqItemIdToOpenOnLoad = this.$route.query.entry
        const faqItemToOpen = this.$refs[faqItemIdToOpenOnLoad]?.[0]
        if (faqItemToOpen) {
          faqItemToOpen.accordionClicked()
          this.scrollIntoEl(faqItemIdToOpenOnLoad, this.$refs)
        }
      }

      if (this.$route.hash) {
        openFaqTopicFromQuery()
      } else {
        openFaqItemFromQuery()
      }
    })
  },
}
</script>
